import { LitElement, html, utils } from '@hh/global.js'
const { getCart, addToCart, updateCart, reRenderShopifySections } = utils

class HHFreeSamples extends LitElement {
  static properties = {
    threshold: {
      type: Number,
    },
    active: {
      type: Boolean,
    },
    hasFreeSample: {
      type: Boolean,
      attribute: 'data-has-free-samples',
    },
  }

  constructor() {
    super()
    this.items = JSON.parse(this.dataset.initialSamples).map((item) => +item)

    if (!!this.dataset.unavailable) {
      this.clearFreeSamples()
    }
  }

  get freeSampleTrigger() {
    return this.querySelector('#free-sample-selector__trigger')
  }

  connectedCallback() {
    super.connectedCallback()

    document.addEventListener('CART:TEMPLATE_UPDATE', this.reapplyWarningLogic.bind(this));

    this.freeSampleTrigger?.addEventListener(
      'input',
      this.handleFreeSamples.bind(this)
    )
    this.handleSamples()
    this.applyInitialErrorState()
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    document.removeEventListener('CART:TEMPLATE_UPDATE', this.reapplyWarningLogic);
    this.freeSampleTrigger?.removeEventListener('input', this.handleFreeSamples)
  }

  async handleSamples() {
    let autoDisabled = sessionStorage.getItem('Free_Samples_Disable_Auto') == 'true'
    let userDoesntWantSamples = sessionStorage.getItem('freeSamples')
    
    if (
      this.active &&
      this.freeSampleTrigger &&
      userDoesntWantSamples === null &&
      !autoDisabled
    ) {
      this.freeSampleTrigger.checked = true
      this.addFreeSamples()
    } else if(this.freeSampleTrigger) {
      if (this.hasFreeSample && this.active) {
        this.freeSampleTrigger.checked = true
      } else {
        this.freeSampleTrigger.checked = false
      }
    }
  }

  handleFreeSamples(event) {
    const label = this.querySelector('label[for="free-sample-selector__trigger"]');
    const warning = document.getElementById('free-sample-warning');

    if (event.target.checked) {
      this.addFreeSamples()
      if (label) label.classList.remove('free-sample-selector__trigger--error');
      if (warning) warning.style.display = 'none';
    } else {
      sessionStorage.setItem('Free_Samples_Disable_Auto', 'true')
      this.clearFreeSamples(true)
      if (label) label.classList.add('free-sample-selector__trigger--error');
      if (warning) warning.style.display = 'block';
    }
  }

  reapplyWarningLogic() {
    // Ensure the warning message is in the DOM
    const warning = document.getElementById('free-sample-warning');
    if (!warning) {
      const warningMessage = document.createElement('div');
      warningMessage.id = 'free-sample-warning';
      warningMessage.className = 'free-sample-warning';
      warningMessage.textContent = 'Are you sure you want to remove samples from your order?';
      warningMessage.style.display = 'none';
  
      const footer = document.querySelector('hh-button-wrapper');
      if (footer) footer.insertAdjacentElement('beforebegin', warningMessage);
    }
  
    const checkbox = this.freeSampleTrigger;
    const label = this.querySelector('label[for="free-sample-selector__trigger"]');
    if (checkbox && label) {
      if (!checkbox.checked) {
        label.classList.add('free-sample-selector__trigger--error');
        warning.style.display = 'block';
      } else {
        label.classList.remove('free-sample-selector__trigger--error');
        warning.style.display = 'none';
      }
    }
  }

  applyInitialErrorState() {
    const checkbox = this.freeSampleTrigger;
    const label = this.querySelector('label[for="free-sample-selector__trigger"]');
    const warning = document.getElementById('free-sample-warning');
  
    if (!warning) {
      const warningMessage = document.createElement('div');
      warningMessage.id = 'free-sample-warning';
      warningMessage.className = 'free-sample-warning';
      warningMessage.textContent = 'Are you sure you want to remove samples from your order?';
      warningMessage.style.display = 'none';
  
      const footer = document.querySelector('hh-button-wrapper');
      if (footer) footer.insertAdjacentElement('beforebegin', warningMessage);
    }
  
    // If checkbox is unchecked, show error
    if (checkbox && !checkbox.checked) {
      if (label) label.classList.add('free-sample-selector__trigger--error');
      if (warning) warning.style.display = 'block';
    }
  }  

  async addFreeSamples() {
    document.activeElement.blur()

    const cart = await getCart()
    const updatePayload = {}
    const samplesInCart = cart.items
      .filter((item) => item.properties?._free_sample)
      .map((item) => {
        updatePayload[item.key] = 0

        return item.key
      })

    if (samplesInCart.length > 0) {
      document.activeElement.blur()
      await updateCart(
        {
          updates: updatePayload,
        },
        `${this.inlineCartSectionId}`
      )
    }
    const items = this.items.map((id) => ({
      id,
      quantity: 1,
      properties: {
        _free_sample: true,
        _free_sample_threshold: this.threshold,
      },
    }))

    if (items.length > 0) {
      await addToCart({
        items,
      })
    }
    sessionStorage.removeItem('freeSamples')
  }

  async clearFreeSamples(sessionUpdate = false) {
    const cart = await getCart()

    const updates = {}
    const freeSamples = cart.items
      .filter((item) => !!item.properties._free_sample)
      .map((item) => item.key)

    if (freeSamples.length > 0) {
      freeSamples.map((key) => (updates[key] = 0))

      document.activeElement.blur()
      const response = await updateCart({
        updates,
      })
      reRenderShopifySections(response, '[data-rerender]')
      document.querySelector('hh-mini-cart')?.checkCartStatus()
    }
    if (sessionUpdate) {
      sessionStorage.setItem('freeSamples', 'false')
    }
  }

  render() {
    return html`<div>
      <slot name="body"></slot>
    </div> `
  }
}

customElements.define('free-sample-selector', HHFreeSamples)
